const fonts = {
  size: {
    large: '26px',
    medium: '20px',
    regular: '14px',
    default: '12px',
    small: '10px'
  },
  family: {
    regular: '"Metropolis-Regular", sans-serif',
    semiBold: '"Metropolis-SemiBold", "Metropolis", sans-serif'
  }
};

export default fonts;
